/**
 * Links internos sem prender o design system a um roteador. O app entrega o componente de link dele
 * (ex.: Link do React Router); sem provedor (Storybook), vira <a href>.
 */
import { createContext, useContext, type ComponentType, type ReactNode } from "react";

export type PropsLink = { href: string; className?: string; children: ReactNode; "aria-current"?: "page" | undefined; onClick?: () => void; role?: string; "aria-label"?: string; "aria-describedby"?: string; title?: string };
const Padrao: ComponentType<PropsLink> = ({ href, children, ...p }) => <a href={href} {...p}>{children}</a>;
const Ctx = createContext<ComponentType<PropsLink>>(Padrao);

export function ProvedorNavegacao({ link, children }: { link: ComponentType<PropsLink>; children: ReactNode }) {
  return <Ctx.Provider value={link}>{children}</Ctx.Provider>;
}

export function LinkInterno(p: PropsLink) {
  const L = useContext(Ctx);
  return <L {...p} />;
}
